<template>
  <div>
    <a-card title="产品信息">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="编号, 名称, 备注" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <a-col :span="24" style="width: 300px; margin-bottom: 12px;">
          <a-button-group>
            <a-button icon="file-excel" @click="downloadTemplate">模板下载</a-button>
            <a-upload name="file" :showUploadList="false" :customRequest="importExcel">
              <a-button icon="upload">导入</a-button>
            </a-upload>
            <a-button icon="download" @click="exportExcel">导出</a-button>
          </a-button-group>
        </a-col>

        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal(form)">新增产品</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange">
          <div slot="images" slot-scope="value">
            <template v-if="value && value[0]">
              <template v-if="isImageFile(getFileUrl(value[0]))">
                <img style="width: 60px; height: 60px; object-fit: cover; cursor: pointer; border-radius: 4px;"
                  :src="getFileUrl(value[0])"
                  @click="onClick(getFileUrl(value[0]))" />
              </template>
              <template v-else>
                <a :href="getFileUrl(value[0])" target="_blank" style="text-decoration: none;">
                  <div style="width:60px; height:60px; border:1px solid #e8e8e8; border-radius:4px; display:flex; flex-direction:column; align-items:center; justify-content:center; background:#f5f5f5; cursor:pointer;">
                    <a-icon :type="getFileIcon(getFileUrl(value[0]))" style="font-size:22px; color:#1890ff;" />
                    <span style="font-size:10px; color:#666; margin-top:4px; text-transform:uppercase;">{{ getFileExt(getFileUrl(value[0])) }}</span>
                  </div>
                </a>
              </template>
            </template>
          </div>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? '激活' : '冻结' }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal :visible="visible" :form="targetItem" @getClassInfo="getClassInfo" @getUnitInfo="getUnitInfo"
      :classificationItems="classificationItems" :listItem="items_yuanliao" :unitItems="unitItems"
      :warehouseItems="warehouseItems" @create="create" @update="update" />
    <a-modal v-model="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div>
        <a-spin style="margin-right: 12px;" />正在导入中, 请等待...
      </div>
    </a-modal>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/excel'
import { goodsInformationExport } from '@/api/export'
import { goodsInformationTemplate, goodsInformationImport } from '@/api/import'
import { goodsInformationList, goodsInformationDestroy } from '@/api/goods'
import { goodsClassificationOption, goodsUnitOption, warehousesOption } from '@/api/option'
import { getGoodsNumber } from '@/api/data'

export default {
  name: 'Warehouse',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
        },
        {
          title: '产品id',
          dataIndex: 'id',
          sorter: true,
        },
        {
          title: '示例图',
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' }
        },
        {
          title: '产品编号',
          dataIndex: 'number',
          sorter: true,
        },
        {
          title: '产品名称',
          dataIndex: 'name',
          sorter: true,
        },
        {
          title: '分类',
          dataIndex: 'category_name',
        },
        {
          title: '采购价',
          dataIndex: 'purchase_price',
        },
        {
          title: '零售价',
          dataIndex: 'retail_price',
        },
        {
          title: '单位',
          dataIndex: 'unit_name',
        },
        {
          title: '状态',
          dataIndex: 'is_active',
          scopedSlots: { customRender: 'is_active' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '156px'
        },
      ],
      searchForm: { search: '', page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      items_yuanliao: [],
      items_product: [],
      classificationItems: [],
      unitItems: [],
      warehouseItems: [],
      visible: false,
      targetItem: {
        types: undefined,
        period_unit: '天',
        category: undefined,
        unit: undefined,
        is_active: true,
        images: [],
        association: [],
      },
      form: {
        types: undefined,
        period_unit: '天',
        category: undefined,
        unit: undefined,
        is_active: true,
        images: [],
        association: [],
      },
      importLoading: false,
    };
  },
  methods: {
    getMaterial() {
      goodsInformationList({ page: 1, page_size: 999, is_active: true, types: 'material' }).then(data => {
        this.items_yuanliao = data.results.filter(function (item) {
          return item.types !== "product";
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    getFileUrl(file) {
      if (!file) return ''
      if (typeof file === 'string') return file
      return (file.response && file.response.data && file.response.data.file_url) || file.url || ''
    },
    isImageFile(url) {
      if (!url) return false
      return /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i.test(url)
    },
    getFileExt(file) {
      const url = this.getFileUrl(file)
      if (!url) return 'FILE'
      const ext = url.split('/').pop().split('?')[0].split('.').pop()
      return ext ? ext.toUpperCase() : 'FILE'
    },
    getFileIcon(file) {
      const ext = this.getFileExt(file).toLowerCase()
      if (['xls', 'xlsx'].includes(ext)) return 'file-excel'
      if (['doc', 'docx'].includes(ext)) return 'file-word'
      if (ext === 'pdf') return 'file-pdf'
      if (['zip', 'rar', '7z'].includes(ext)) return 'file-zip'
      if (['txt', 'csv'].includes(ext)) return 'file-text'
      return 'file'
    },
    getFileName(url) {
      if (!url) return ''
      return url.split('/').pop().split('?')[0]
    },
    onClick(val) {
      this.previewVisible = true
      this.previewImage = val
    },
    initialize() {
      this.list();
    },
    getClassInfo() {
      goodsClassificationOption({ page_size: 999999, is_active: true }).then((resp) => {
        this.classificationItems = resp.results;
      });
    },
    getUnitInfo() {
      goodsUnitOption({ page_size: 999999, is_active: true }).then((resp) => {
        this.unitItems = resp.results;
      });
    },
    list() {
      this.loading = true;
      goodsInformationList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;

        this.items_product = data.results.filter(function (item) {
          return item.types === "product";
        });


      }).finally(() => {
        this.loading = false;
      });
    },
    create(item) {
      // this.items.splice(0, 0, item);
      this.list();
      this.getMaterial();
      this.visible = false
    },
    update(item) {
      this.list();
      this.getMaterial();
      this.visible = false
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal(item) {
      // item.shelf_life_days = item.shelf_life_days && item.shelf_life_days.replace(/\D/g, "");
      if (!item.id) {
        getGoodsNumber().then(data => {
          this.targetItem = { ...JSON.parse(JSON.stringify(item)), number: data.number, images: [], types: 'product' };
        })
      } else {
        // this.targetItem = { ...item, ...{ images: item.images } };
        this.targetItem = {
          ...item, ...{
            images: item.images && item.images.map((img, index) => {
              if (!img.response) {
                const n = img.split('/')
                return {
                  uid: index + '',
                  name: n[n.length - 1],
                  status: 'done',
                  url: img,
                }
              } else {
                return img
              }
            }) || [],
            association: item.association || [],
            period_unit: item.period_unit || '天',
            category: item.category != null ? item.category : undefined,
            unit: item.unit != null ? item.unit : undefined,
            is_active: item.is_active != null ? item.is_active : true,
          }
        };
      }
      this.getClassInfo();
      this.getUnitInfo();
      warehousesOption({ page_size: 999999, is_active: true }).then((resp) => {
        if (!item.id) {
          this.warehouseItems = resp.results
        } else {
          this.warehouseItems = resp.results && resp.results.map(warehouseItem => {
            const inventoryItems = item.inventory_items || [];
            let index = inventoryItems.findIndex(_item => _item.warehouse == warehouseItem.id);
            if (index != -1) {
              warehouseItem.initial_quantity = inventoryItems[index].initial_quantity;
              warehouseItem.batch_items = inventoryItems[index].batch_items;
            }
            return warehouseItem
          });
        }
      });
      this.visible = true;
    },
    destroy(id) {
      goodsInformationDestroy({ id }).then(() => {
        // this.items.splice(this.items.findIndex(item => item.id == id), 1);
        this.$message.success('删除成功');
        this.list();
      });
    },
    exportExcel() {
      goodsInformationExport(this.searchForm).then(resp => {
        exportExcel(resp.data, '产品信息列表');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    downloadTemplate() {
      goodsInformationTemplate().then(resp => {
        exportExcel(resp.data, '产品信息导入模板');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    importExcel(item) {
      let data = new FormData();
      data.append('file', item.file);
      this.importLoading = true;
      setTimeout(() => {
        goodsInformationImport(data)
          .then(() => {
            this.$message.success('导入成功');
            this.list();
          })
          .catch(err => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order === 'descend' ? '-' : ''}${sorter.field}`;
      this.list();
    },
  },
  mounted() {
    this.initialize();
    this.getMaterial();
  },
}
</script>
